package presentation.screens.customer.membership

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Home
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import common.asset.ImageAsset
import common.constants.KeyConstant
import common.constants.UserDefaults
import component.image.AsyncImageView
import component.image.FriendlyIcon
import component.navigation.TopNavBar
import feature.auth.viewModel.AuthViewModel
import feature.customer.viewModel.CustomerViewModel
import theme.ThemeColor

class MembershipDetailsScreen : Screen {
    var authViewModel: AuthViewModel? = null
    var viewModel: CustomerViewModel? = null

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.current
        val customer = viewModel?.customer?.collectAsState()
        val user = authViewModel?.authUser?.collectAsState()
        LaunchedEffect(key1 = Unit) {
            if (!user?.value?.mobile.isNullOrEmpty() && !user?.value?.DialCode.isNullOrEmpty()) {
                viewModel?.loadMembership(
                    mobile = user?.value?.mobile!!, dialCode = user.value.DialCode!!
                )
            }
        }
        if (!customer?.value?.barcode.isNullOrEmpty()) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight()
            ) {
                TopNavBar("", onBackPress = {
                    navigator?.pop()
                })
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(Color(0xFFFFFFFF), shape = RoundedCornerShape(10.dp))
                        .clip(RoundedCornerShape(10.dp))
                        .padding(5.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        Icons.Default.Home,
                        contentDescription = "Home",
                        modifier = Modifier.weight(0.05f), tint = ThemeColor.shared().PrimaryColor
                    )
                    AsyncImageView(customer?.value!!.barCodeImage!!) {
                        UserDefaults.remove(
                            KeyConstant.membershipDetails
                        )
                        if (!authViewModel?.authUser?.value?.mobile.isNullOrEmpty() && authViewModel?.authUser?.value?.DialCode.isNullOrEmpty()) {
                            viewModel?.loadMembership(
                                authViewModel?.authUser?.value?.mobile!!,
                                authViewModel?.authUser?.value?.DialCode!!
                            )
                        }
                    }
                    FriendlyIcon(ImageAsset.arrowRightIcon)
                }
            }

        } else {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight()
            ) {
                TopNavBar("", onBackPress = {
                    navigator?.pop()
                })
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(70.dp)
                        .background(Color(0x8DB3B0B0), shape = RoundedCornerShape(10.dp))
                        .clip(RoundedCornerShape(10.dp))

                        .padding(5.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {

                    Text(
                        "No Membership found, please visit our store",
                        modifier = Modifier.weight(0.2f)
                    )
                }
            }

        }
    }

}